import { Component, HostBinding, HostListener } from '@angular/core';
import { ToastService } from './toast.service';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
	selector: 'app-toast-animated',
	templateUrl: './toast.component.html',
	styleUrls: ['./toast.component.scss'],
	animations: [
		trigger('EnterLeave', [
			state('first', style({ transform: 'translateY(calc(-100% - 90px))', position: 'absolute' })),
			transition(':leave', [
				animate('0.3s ease-in', style({ transform: 'translate(calc(-100% - 100px), calc(-100% - 90px)', opacity: 0 })),
				style({ pointerEvents: 'none' })
			]),
			transition('notFirst => first', [
				animate('0.3s 0.1s ease-in')
			]),
			transition('* => first', [
				animate('0.3s ease-in')
			]),
			transition('* => notFirst', [
				animate('0.3s 0.3s ease-in')
			]),
		]),
	]

})
export class ToastComponent {

	public toastQueue = [];
	@HostBinding('style.top') screenHeight = (window.innerHeight) + "px";

	constructor(private toastService: ToastService) {
		this.toastService.toastQueue$.subscribe((value) => {
			this.toastQueue = value;
		})
	}

	identify(index, item) {
		return item.id;
	}

	closeClick(data: any, index: number) {
		if(index === 0) {
			data = { id: data.id, data: false };
			this.toastService.notify(data);
		}
	}

	protected firstToastHeight(){
		let css = document.querySelector('.md-toast');

		return window.getComputedStyle(css).height;
	}

	protected  toastState(index: number){
		return index === 0 ? 'first' : 'notFirst';
	}

	@HostListener('window:resize')
	onResize() {
		this.screenHeight = (window.innerHeight) + "px";
	}
}
